<template>
  <div
    :class="`
      workbench-workpackage
      ${color}
      ${text_color}--text
      ${color.includes('lighten') || color.includes('darken')? '':'lighten-1'}
      t-rounded
      t-shadow
      font-weight-light

      `"
    :style="`
      ${height?`height: ${height};`:''}
      ${width?`width: ${width};`:''}
      ${margin?`margin: ${margin};`:''}
    `"
    >
    <!-- <div class="workbench-workpackage-header-vertical">
      <slot name="header-vertical"/>
    </div> -->
    <div v-if="!no_header" class="workbench-workpackage-header">
      <slot name="header"/>
    </div>
    <div
      class="workbench-workpackage-content"
      :style="`
        ${tabs?'box-shadow: 0px -2px 2px 0px rgba(0, 0, 0, 0.2) !important;':''}
        ${footer?'height: calc(100% - 33px - 30px);':''}
        ${center_content?'justify-content: center;':''}
      `"
      >
      <slot name="content"/>
    </div>
    <template v-if="footer">
      <v-spacer/>
      <div
      class="workbench-workpackage-footer"
      >
        <slot name="footer"/>
      </div>
    </template>
  </div>
</template>
<script>
  export default {
    props: [
      'color',
      'text_color',
      'height',
      'width',
      'margin',
      'tabs',
      'no_header',
      'footer',
      'center_content'
    ]
  }
</script>
<style>
  .workbench-workpackage {
    height: 100%;
    width: 100%;
    flex-shrink: 0;
    transition: all ease-in-out 0.2s;
    color: black;
    z-index: 0; /* QUICK FIX - it was 1 before */
  }
  .workbench-workpackage-header {
    display: flex;
    width: 100%;
    height: 33px;
    user-select: none;
    overflow: hidden;
  }
  .workbench-workpackage-header-vertical {
    width: 30px;
    height: 100%;
    writing-mode: tb-rl;
    writing-mode: vertical-rl;
    transform:rotate(180deg);
    text-align: center;
    cursor: pointer;
    user-select: none;
  }
  .workbench-workpackage-content {
    display: flex;
    height: calc(100% - 33px);
    flex-direction: column;
    padding: 3px;
    z-index: 0;
    }
  .workbench-workpackage-footer {
    display: flex;
    height: 30px;
    flex-direction: column;
    padding: 3px;
    z-index: 0;
    font-size: 12px;
    line-height: 13px;
    user-select: none;
    }
</style>
